<template>
    <!-- video: -->
    <my-drawer @hideMask="hideMaskForDrawer" :drawerFlag="drawerFlag" backgroundColorForSon="rgba(255, 255, 255, .3)">
        <div class="player_outer_box" @mouseenter="playerOuterBoxMouseEnter" @mouseleave="playerOuterBoxMouseLeave">
            <div class="player-container" @click="clickForSliderBarContainerClose">
                <vue-core-video-player :src="videoSrc" v-if="vueCoreVideoPlayerShowOrClose"></vue-core-video-player>
            </div>
            <!-- 新增分段播放的按钮： -->
            <div class="player_list_button" @click="clickForSliderBarContainerShow" v-if="playerListButtonShow">
                章节
            </div>
            <!-- 分段侧边框： -->
            <div class="slider_bar_container" :style="{ right: sliderBarContainerShow ? '0' : '-340px' }">
                <!-- <div class="slider_bar_container_for_close" @click="clickForSliderBarContainerClose">
                    收起
                </div> -->
                <div class="slider_bar_container_inner_title">
                    选集
                </div>
                <div class="slider_bar_container_inner_list">
                    <div class="slider_bar_container_inner_item" v-for="(item, index) in videoSrcList" :key="index" @click="checkForOneOfVideoList(item)" :style="{ color: item === videoSrc ? '#5FC188' : '#F5F5F5' }">
                        <!-- 第{{index}}段：{{item}} -->
                        直播 1-{{ index + 1 }}
                    </div>
                </div>
            </div>
        </div>
    </my-drawer>
</template>

<script>
export default {
    components: {
        'my-drawer': () => import("../../components/my_drawer")
    },
    props: {
        drawerFlag: {
            type: Boolean,
            default: false
        },
        videoSrc: {
            type: String,
            default: ''
        },
        videoSrcList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            sliderBarContainerShow: false,
            playerListButtonShow: false,
            vueCoreVideoPlayerShowOrClose: true
        }
    },
    methods: {
        hideMaskForDrawer() {
            this.$emit('hideMaskForDrawer')
            this.clickForSliderBarContainerClose()
        },
        checkForOneOfVideoList(item) {
            this.$emit('videoSrcChangeByChild', '')
            this.vueCoreVideoPlayerShowOrClose = false
            setTimeout(() => {
                this.$emit('videoSrcChangeByChild', item)
                this.vueCoreVideoPlayerShowOrClose = true
            }, 30)
        },
        clickForSliderBarContainerShow() {
            this.sliderBarContainerShow = true
        },
        clickForSliderBarContainerClose() {
            this.sliderBarContainerShow = false
        },
        playerOuterBoxMouseEnter() {
            this.playerListButtonShow = true
        },
        playerOuterBoxMouseLeave() {
            this.playerListButtonShow = false
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin verticalAndCrosswiseCenter {
    display: flex;
    justify-content: center;
    align-items: center;
}
.player_outer_box {
    height: 100%;
    padding: 30px;
    border-radius: 20px 20px 0 0;
    position: relative;
    overflow: hidden;
    .player-container {
        height: 100%;
    }
    .player_list_button {
        width: 50px;
        height: 30px;
        position: absolute;
        right: 240px;
        bottom: 44px;
        @include verticalAndCrosswiseCenter();
        z-index: 99;
        color: #aa422f;
        cursor: pointer;
        user-select: none;
        &:hover {
            color: #c24d38;
        }
    }
    .slider_bar_container {
        width: 300px;
        height: 100%;
        background-color: rgba(0, 0, 0, .7);
        position: absolute;
        top: 0;
        // right: 0;
        // right: -150px;
        z-index: 999;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        border: 1px solid #222;
        transition: all 0.5s;
        .slider_bar_container_for_close {
            content: "收起";
            width: 40px;
            height: 30px;
            background-color: rgba(0, 0, 0, .7);
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: -40px;
            font-size: 12px;
            @include verticalAndCrosswiseCenter();
            color: #DDD;
            border-radius: 5px 0 0 5px;
            cursor: pointer;
            &:hover {
                color: #FFF;
            }
        }
        .slider_bar_container_inner_title {
            width: 100%;
            height: 60px;
            line-height: 60px;
            position: relative;
            padding-left: 35px;
            font-size: 20px;
            color: #fff;
            &::before {
                content: "";
                width: 5px;
                height: 40px;
                background-color: #5FC188;
                border-radius: 3px;
                position: absolute;
                top: 50%;
                left: 20px;
                transform: translateY(-50%);
            }
        }
        .slider_bar_container_inner_list {
            flex: 1;
            padding: 20px;
            overflow-y: auto;
            .slider_bar_container_inner_item {
                width: 100%;
                height: 40px;
                color: #F5F5F5;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 40px;
                cursor: pointer;
                &:hover {
                    color: #ccc;
                }
            }
        }
    }
}
</style>